export const SET_RESTAURANT_CODE_SUCCESS = 'RESTAURANT.SET_RESTAURANT_CODE_SUCCESS';

export const CHANGE_TEMPLATE_SUCCESS = 'TEMPLATE.CHANGE_TEMPLATE_SUCCESS';
export const CHANGE_LANGUAGE_SUCCESS = 'LANGUAGE.CHANGE_LANGUAGE_SUCCESS';

export const GET_BASKET_SUCCESS = 'BASKET.GET_BASKET_SUCCESS';
export const UPDATE_FULFILLMENT_SUCCESS = 'BASKET.UPDATE_FULFILLMENT_SUCCESS';
export const SET_BASKET_CONSUMER_SUCCESS = 'BASKET.SET_BASKET_CONSUMER_SUCCESS';
export const ADD_VOUCHER_BASKET_SUCCESS = 'BASKET.ADD_VOUCHER_BASKET_SUCCESS';
export const SET_BASKET_FULFILLAT_SUCCESS = 'BASKET.SET_BASKET_FULFILLAT_SUCCESS';
export const DELETE_BASKET_SUCCESS = 'BASKET.DELETE_BASKET_SUCCESS';
export const UPDATE_BASKET_ITEM_IN_STORE_SUCCESS = 'BASKET.UPDATE_BASKET_ITEM_IN_STORE_SUCCESS';
export const REMOVE_BASKET_ITEM_SUCCESS = 'BASKET.REMOVE_BASKET_ITEM_SUCCESS';
export const UPDATE_BASKET_ITEM_SUCCESS = 'BASKET.UPDATE_BASKET_ITEM_SUCCESS';

export const SET_PAYMENT_METHOD_SUCCESS = 'BASKET_ITEM.SET_PAYMENT_METHOD_SUCCESS';
export const RESET_BASKET_ITEM_SUCCESS = 'BASKET_ITEM.RESET_BASKET_ITEM_SUCCESS';
export const RESET_BASKET_ITEM_ORIGINAL_STATE_SUCCESS = 'BASKET_ITEM.RESET_BASKET_ITEM_ORIGINAL_STATE_SUCCESS';
export const UPDATE_BASKET_ITEM_SIZE_SUCCESS = 'BASKET_ITEM.UPDATE_BASKET_ITEM_SIZE_SUCCESS';
export const UPDATE_BASKET_ITEM_OPTIONS_SUCCESS = 'BASKET_ITEM.UPDATE_BASKET_ITEM_OPTIONS_SUCCESS';
export const UPDATE_BASKET_ITEM_QUANTITY_SUCCESS = 'BASKET_ITEM.UPDATE_BASKET_ITEM_QUANTITY_SUCCESS';
export const LOAD_EXISTING_BASKET_ITEM_SUCCESS = 'BASKET_ITEM.LOAD_EXISTING_BASKET_ITEM_SUCCESS';
export const UPDATE_BASKET_ITEM_COMMENTS_SUCCESS = 'BASKET_ITEM.UPDATE_BASKET_ITEM_COMMENTS_SUCCESS';

export const PLACE_BASKET_ORDER_SUCCESS = 'ORDER.PLACE_BASKET_ORDER_SUCCESS';

export const UPDATING_SIDE_BASKET_SUCCESS = 'LOADING.UPDATING_SIDE_BASKET_SUCCESS';

export const SET_SERVER_ERROR = 'ERROR.SET_SERVER_ERROR';
export const SET_FULFILLMENT_ERROR = 'ERROR.SET_FULFILLMENT_ERROR';
export const SET_ITEM_ERROR = 'ERROR.SET_ITEM_ERROR';

export const SET_PAYMENT_ERROR = 'ERROR.SET_PAYMENT_ERROR';

export const SET_CHECKOUTDATA_SUCCESS = 'SET_CHECKOUTDATA_SUCCESS';

export const GET_TABLE_BOOKING_CONFIG_SUCCESS = 'BOOKING.GET_TABLE_BOOKING_CONFIG_SUCCESS';
export const SET_TABLE_BOOKING_SUCCESS = 'BOOKING.SET_TABLE_BOOKING_SUCCESS';

export const SET_ORDER_SOURCE = 'ORDER_SOURCE.SET_ORDER_SOURCE';

export const SET_SERVER_OFFLINE_SUCCESS = 'SERVER.SET_SERVER_OFFLINE_SUCCESS';

export const SET_UPSELLING_MODAL_CANCELLED_SUCCESS = 'UPSELLING.SET_UPSELLING_MODAL_CANCELLED_SUCCESS';
export const SEND_SLACK_MESSAGE = 'CHECKOUT.SEND_SLACK_MESSAGE';



// WEBPACK FOOTER //
// ./actions/types.action.js